import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import PowerSearch from "./PowerSearch";
import SearchMonster from "./SearchMonster";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { MonsterBooleanSearch } from "./MonsterBooleanSearch";

const recentHistory = [
  { id: 1, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex)', date: "03/24/26 13:17:29" },
  { id: 2, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex) in United States', date: "03/24/26 13:17:18" },
  { id: 3, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex) in United States', date: "03/24/26 13:17:05" },
  { id: 4, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex) in United States', date: "03/24/26 13:16:46" },
  { id: 5, query: '("IS-U" or isu) and sap', date: "03/23/26 18:08:47" },
  { id: 6, query: '("IS-U" or isu) and sap', date: "03/23/26 18:08:40" },
  { id: 7, query: '("IS-U" or isu) and sap in United States', date: "03/23/26 18:06:37" },
  {
    id: 8,
    query: '("Technical Project Manager" OR "Technical Program Manager" OR TPM) AND n8n and automation in United States',
    date: "03/20/26 12:52:18",
  },
];

const savedHistory = [
  { id: 1, query: '("CA Plex" OR "CA-Plex" OR Plex) in United States', date: "03/20/26 10:00:00" },
  { id: 2, query: '("IS-U" or isu) and sap in United States', date: "03/19/26 09:30:00" },
];

const fromOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 3 Days", value: "3days" },
  { label: "Last Week", value: "week" },
];
const toOptions = [
  { label: "1 month", value: "1month" },
  { label: "3 months", value: "3months" },
  { label: "6 months", value: "6months" },
  { label: "1 year", value: "1year" },
];
const countryOptions = [
  { label: "United States", value: "us" },
  { label: "Canada", value: "ca" },
  { label: "United Kingdom", value: "uk" },
];
const radiusOptions = [
  { label: "10 miles away", value: "10" },
  { label: "25 miles away", value: "25" },
  { label: "50 miles away", value: "50" },
  { label: "100 miles away", value: "100" },
];
const stateOptions = [
  { label: "California", value: "CA" },
  { label: "New York", value: "NY" },
  { label: "Texas", value: "TX" },
  { label: "Florida", value: "FL" },
];
const experienceOptions = [
  { label: "No Min", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "5", value: "5" },
  { label: "10", value: "10" },
];
const maxExpOptions = [
  { label: "No Max", value: "0" },
  { label: "5", value: "5" },
  { label: "10", value: "10" },
  { label: "15", value: "15" },
  { label: "20+", value: "20" },
];
const jobStatusOptions = [
  { label: "All Relocation Levels", value: "all" },
  { label: "Willing to Relocate", value: "willing" },
  { label: "Not Willing to Relocate", value: "not" },
];
const languageOptions = [
  { label: "Select Language", value: "select" },
  { label: "English", value: "en" },
  { label: "Spanish", value: "es" },
  { label: "French", value: "fr" },
];
const proficiencyOptions = [
  { label: "Beginner", value: "beginner" },
  { label: "Intermediate", value: "intermediate" },
  { label: "Fluent", value: "fluent" },
  { label: "Native", value: "native" },
];
const companyOptions = [
  { label: "Select Company", value: "" },
  { label: "Google", value: "google" },
  { label: "Microsoft", value: "microsoft" },
  { label: "Amazon", value: "amazon" },
];

// ─── Component ─────────────────────────────────────────────────────────────────

const Monster = () => {
  // ── View mode ──
  // const [isPowerSearch, setIsPowerSearch] = useState(false);
  const [view, setView] = useState<"classic" | "power" | "monster">("monster");

  // ── Toggle panels ──
  const [showMoreResume, setShowMoreResume] = useState(false);
  const [showMoreProfile, setShowMoreProfile] = useState(false);

  // ── Form state ──
  const [keyword, setKeyword] = useState("(ER or emergency room) and (BLS or basic life support)");
  const [from, setFrom] = useState("today");
  const [to, setTo] = useState("1month");
  const [locationMode, setLocationMode] = useState("zip");
  const [country, setCountry] = useState("us");
  const [radius, setRadius] = useState("50");
  const [zipCode, setZipCode] = useState("");
  const [searchCountry, setSearchCountry] = useState("us");
  const [state, setState] = useState<string | null>(null);
  const [includeEmployable, setIncludeEmployable] = useState(false);
  const [includeAuthorized, setIncludeAuthorized] = useState(false);

  // More Resume fields
  const [resumeManager, setResumeManager] = useState("");
  const [resumeTitle, setResumeTitle] = useState("");
  const [resumeLastUpdated, setResumeLastUpdated] = useState("");
  const [resumeLastDocument, setResumeLastDocument] = useState("");
  const [schoolAttended, setSchoolAttended] = useState("");
  const [minExp, setMinExp] = useState("0");
  const [maxExp, setMaxExp] = useState("0");
  const [showRelocate, setShowRelocate] = useState(false);

  // Profile fields
  const [jobStatus, setJobStatus] = useState("all");
  const [careerLevel, setCareerLevel] = useState<Record<string, boolean>>({
    student: false,
    entryLevel: false,
    midLevel: false,
    manager: false,
    director: false,
    executive: false,
  });
  const [language, setLanguage] = useState("select");
  const [proficiency, setProficiency] = useState("beginner");
  const [jobNature, setJobNature] = useState<Record<string, boolean>>({
    fullTime: false,
    partTime: false,
    perDiem: false,
  });
  const [jobType, setJobType] = useState<Record<string, boolean>>({
    employee: false,
    contractor: false,
    tempAgency: false,
    seasonal: false,
  });
  const [company, setCompany] = useState("");

  // History
  const [historyTab, setHistoryTab] = useState(0);
  const toast = useRef<any>(null);

  // ── Handlers ──
  const handleSearch = () => alert("Search triggered!");
  const handleHistoryClick = (query: string) => setKeyword(query);

  const updateToken = async () => {
    await Fetch("Monster/token", "GET", null, null, toast);
  }

  useEffect(() => {
    updateToken();
  }, []);

  return (
    <>
      <div className="ml-auto flex align-items-center flex-row-reverse gap-2">
        <Button label="Boolean Search" onClick={() => setView("power")} className="p-button-sm" style={view === "monster" ? { backgroundColor: "white", fontWeight: 600, color: "#aa0be8", border: "0px" } : { backgroundColor: "#aa0be8", fontWeight: 600, color: "white" }} />
        <span style={{ color: "#ccc" }}>|</span>
        <Button label="Semantic Search" onClick={() => setView("monster")} className="p-button-sm" style={view === "power" ? { backgroundColor: "white", fontWeight: 600, color: "#aa0be8", border: "0px" } : { backgroundColor: "#aa0be8", fontWeight: 600, color: "white" }} />
        <span style={{ color: "#666" }}>Switch to</span>
        <i className="pi pi-arrows-h" style={{ color: "#666" }}></i>
      </div>
      <div className="mt-2"></div>
      {view === "monster" && <SearchMonster onSwitchToClassic={() => setView("classic")} onSwitchToPower={() => setView("power")} />}
      {view === "power" && <MonsterBooleanSearch />}
    </>
  )

  // ── Switch to Power Search ──
  if (view === "monster") {
    return <SearchMonster onSwitchToClassic={() => setView("classic")} onSwitchToPower={() => setView("power")} />;
  }
  if (view === "power") {
    return <PowerSearch onSwitchToClassic={() => setView("classic")} onSwitchToMonster={() => setView("monster")} />;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <>
      <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", backgroundColor: "#f4f6f9", minHeight: "100vh" }}>
        {/* ── Top Credit Bar ── */}
        <div className="flex align-items-center gap-3 px-4 py-2 flex-wrap" style={{ backgroundColor: "#fff", borderBottom: "1px solid #e0e0e0", fontSize: "13px" }}>
          {/* <span className="flex align-items-center gap-1">
          Available Credits <Tag value="141999" style={{ backgroundColor: "#28a745", fontSize: "12px" }} />
        </span>
        <span className="flex align-items-center gap-1">
          Used Credits <Tag value="8001" style={{ backgroundColor: "#007bff", fontSize: "12px" }} />
        </span>
        <span className="flex align-items-center gap-1">
          Expiration <Tag value="03/06/27" style={{ backgroundColor: "#dc3545", fontSize: "12px" }} />
        </span>
        <span className="flex align-items-center gap-1">
          Search Type <Tag value="Classic Search" style={{ backgroundColor: "#fd7e14", fontSize: "12px" }} />
        </span>
        <span className="flex align-items-center gap-1">
          Remaining Credits <Tag value="49988 / 50000" style={{ backgroundColor: "#28a745", fontSize: "12px" }} />
        </span> */}

          <div className="ml-auto flex align-items-center gap-2">
            <i className="pi pi-arrows-h" style={{ color: "#666" }}></i>
            <span style={{ color: "#666" }}>Switch to</span>
            <Button label="Power Search" onClick={() => setView("power")} className="p-button-text p-0" style={{ color: "#007bff", fontWeight: 600 }} />
            <span style={{ color: "#ccc" }}>|</span>
            <Button label="Search Monster" onClick={() => setView("monster")} className="p-button-sm" />
          </div>
        </div>

        {/* ── Main Content ── */}
        <div className="flex" style={{ minHeight: "calc(100vh - 48px)" }}>
          {/* ── Left: Search Form ── */}
          <div className="p-4" style={{ flex: "0 0 640px", backgroundColor: "#fff", borderRight: "1px solid #e0e0e0", overflowY: "auto" }}>
            <h2 style={{ color: "#3d5a8a", fontWeight: 700, fontSize: "22px", marginBottom: "20px" }}>Resume Search</h2>

            {/* Keyword */}
            <div className="mb-4">
              <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                Keyword
              </label>
              <div className="flex align-items-center gap-2">
                <InputText value={keyword} onChange={(e) => setKeyword(e.target.value)} className="w-full" style={{ fontSize: "13px" }} />
                <Button className="p-link" onClick={() => console.log("Show tips")} style={{ fontSize: "13px", whiteSpace: "nowrap" }}>
                  Search Tips
                </Button>
              </div>
            </div>

            {/* Resumes Posted */}
            <div className="mb-4">
              <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                Resumes Posted
              </label>
              <div className="flex align-items-center gap-2">
                <span style={{ fontSize: "13px" }}>From</span>
                <Dropdown value={from} options={fromOptions} onChange={(e) => setFrom(e.value)} style={{ fontSize: "13px" }} />
                <span style={{ fontSize: "13px" }}>to</span>
                <Dropdown value={to} options={toOptions} onChange={(e) => setTo(e.value)} style={{ fontSize: "13px" }} />
              </div>
            </div>

            {/* Location */}
            <div className="mb-4">
              <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                Location (Choose 1):
              </label>

              {/* ZIP Radius */}
              <div className="flex align-items-start gap-2 mb-3">
                <RadioButton inputId="zip" value="zip" checked={locationMode === "zip"} onChange={() => setLocationMode("zip")} />
                <label htmlFor="zip" style={{ fontSize: "13px", cursor: "pointer" }}>
                  Search ZIP Code Radius
                </label>
              </div>

              {locationMode === "zip" && (
                <div className="pl-4 mb-3">
                  <div className="flex align-items-center gap-2 mb-2">
                    <label style={{ fontSize: "13px", width: "60px" }}>Country</label>
                    <Dropdown value={country} options={countryOptions} onChange={(e) => setCountry(e.value)} style={{ fontSize: "13px", minWidth: "180px" }} />
                  </div>
                  <div className="flex align-items-center gap-2 flex-wrap">
                    <label style={{ fontSize: "13px" }}>Show Job Seekers Within</label>
                    <Dropdown value={radius} options={radiusOptions} onChange={(e) => setRadius(e.value)} style={{ fontSize: "13px" }} />
                    <label style={{ fontSize: "13px" }}>of ZIP Code/City</label>
                    <InputText value={zipCode} onChange={(e) => setZipCode(e.target.value)} style={{ fontSize: "13px", width: "160px" }} />
                  </div>
                </div>
              )}

              <div className="flex align-items-center gap-2 mb-3" style={{ color: "#007bff", fontWeight: 600, fontSize: "14px" }}>
                -OR-
              </div>

              <div className="flex align-items-start gap-2 mb-2">
                <RadioButton inputId="selected" value="selected" checked={locationMode === "selected"} onChange={() => setLocationMode("selected")} />
                <label htmlFor="selected" style={{ fontSize: "13px", cursor: "pointer" }}>
                  Search Within Selected Locations:
                </label>
              </div>

              {locationMode === "selected" && (
                <div className="pl-4">
                  <div className="flex align-items-center gap-2 mb-2">
                    <label style={{ fontSize: "13px", width: "60px" }}>Country</label>
                    <Dropdown value={searchCountry} options={countryOptions} onChange={(e) => setSearchCountry(e.value)} style={{ fontSize: "13px", minWidth: "180px" }} />
                  </div>
                  <div className="flex align-items-center gap-2">
                    <label style={{ fontSize: "13px", width: "60px" }}>State</label>
                    <Dropdown value={state} options={stateOptions} onChange={(e) => setState(e.value)} placeholder="Select State" style={{ fontSize: "13px", minWidth: "180px" }} />
                  </div>
                </div>
              )}

              <div className="mt-3 flex flex-column gap-2">
                <div className="flex align-items-center gap-2">
                  <Checkbox inputId="employable" checked={includeEmployable} onChange={(e) => setIncludeEmployable(!!e.checked)} />
                  <label htmlFor="employable" style={{ fontSize: "13px" }}>
                    Include Job Seekers Employable in Any of the Selected Locations.
                  </label>
                </div>
                <div className="flex align-items-center gap-2">
                  <Checkbox inputId="authorized" checked={includeAuthorized} onChange={(e) => setIncludeAuthorized(!!e.checked)} />
                  <label htmlFor="authorized" style={{ fontSize: "13px" }}>
                    Include Job Seekers Authorized to Work for any Employer in Any of the Selected Locations.
                  </label>
                </div>
              </div>
            </div>

            <Divider />

            {/* ✅ More Resume Search toggle */}
            <div className="mb-3">
              <Button
                onClick={() => setShowMoreResume((prev) => !prev)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#007bff",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <i className={`pi ${showMoreResume ? "pi-chevron-up" : "pi-chevron-down"}`} style={{ fontSize: "11px" }}></i>
                More Resume Search
              </Button>
            </div>

            {/* ✅ More Resume Search — collapsible section */}
            {showMoreResume && (
              <div className="mb-4 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef" }}>
                <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                  Resume Details
                </label>
                <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Filter Resumes by the Details of the Resume/Resumes.</p>
                <div className="flex flex-column gap-2">
                  {[
                    { label: "Resume Manager", value: resumeManager, setter: setResumeManager },
                    { label: "Resume Title", value: resumeTitle, setter: setResumeTitle },
                    { label: "Resume Last Updated", value: resumeLastUpdated, setter: setResumeLastUpdated },
                    { label: "Resume Last Document", value: resumeLastDocument, setter: setResumeLastDocument },
                    { label: "School Attended", value: schoolAttended, setter: setSchoolAttended },
                  ].map((field) => (
                    <div key={field.label}>
                      <label style={{ fontSize: "12px", color: "#666" }}>{field.label}</label>
                      <InputText value={field.value} onChange={(e) => field.setter(e.target.value)} className="w-full mt-1" style={{ fontSize: "13px" }} />
                    </div>
                  ))}
                </div>

                <Divider />

                <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                  Desired Salary
                </label>
                <div className="flex align-items-center gap-2 flex-wrap mb-2">
                  <label style={{ fontSize: "13px" }}>Min</label>
                  <Dropdown value={minExp} options={experienceOptions} onChange={(e) => setMinExp(e.value)} style={{ fontSize: "13px" }} />
                  <label style={{ fontSize: "13px" }}>Max</label>
                  <Dropdown value={maxExp} options={maxExpOptions} onChange={(e) => setMaxExp(e.value)} style={{ fontSize: "13px" }} />
                </div>
                <div className="flex align-items-center gap-2">
                  <Checkbox inputId="relocate" checked={showRelocate} onChange={(e) => setShowRelocate(!!e.checked)} />
                  <label htmlFor="relocate" style={{ fontSize: "13px" }}>
                    Show Resumes Without a Desired Salary
                  </label>
                </div>
              </div>
            )}

            <Divider />

            {/* Job Seeker Profile */}
            <div className="mb-4">
              <label className="block mb-2 font-semibold" style={{ fontSize: "14px" }}>
                Job Seeker Profile
              </label>
              <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Show Job Seekers with the Resume/Resumes Listed in Region:</p>
              <Dropdown value={jobStatus} options={jobStatusOptions} onChange={(e) => setJobStatus(e.value)} className="w-full" style={{ fontSize: "13px" }} />
            </div>

            {/* More Profile Options toggle */}
            <div className="mb-3">
              <Button onClick={() => setShowMoreProfile((prev) => !prev)} className="flex align-items-center gap-2 p-0 border-none bg-transparent cursor-pointer text-primary" style={{ fontSize: "13px" }}>
                <span>More Profile Options</span>

                <i className={`pi ${showMoreProfile ? "pi-chevron-up" : "pi-chevron-down"}`} style={{ fontSize: "12px" }}></i>
              </Button>
            </div>

            {/*  More Profile Options — collapsible section */}
            {showMoreProfile && (
              <div className="mb-4 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef" }}>
                {/* Career Level */}
                <div className="mb-4">
                  <label className="block mb-1 font-semibold" style={{ fontSize: "14px" }}>
                    Career Level
                  </label>
                  <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Only include resumes with the selected career levels:</p>
                  <div className="flex flex-column gap-2">
                    {[
                      { key: "student", label: "Student (High School)" },
                      { key: "entryLevel", label: "Entry Level" },
                      { key: "midLevel", label: "Experienced (Non-Manager)" },
                      { key: "manager", label: "Manager (Manager/Supervisor of Staff)" },
                      { key: "director", label: "Executive (SVP, VP, Department Head, etc)" },
                      { key: "executive", label: "Senior Executive (President, CEO, etc)" },
                    ].map((item) => (
                      <div key={item.key} className="flex align-items-center gap-2">
                        <Checkbox inputId={item.key} checked={careerLevel[item.key]} onChange={(e) => setCareerLevel((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                        <label htmlFor={item.key} style={{ fontSize: "13px" }}>
                          {item.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <Divider />

                {/* Language Proficiency */}
                <div className="mb-4">
                  <label className="block mb-1 font-semibold" style={{ fontSize: "14px" }}>
                    Language Proficiency
                  </label>
                  <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Only include resumes with the selected language proficiency levels:</p>
                  <div className="flex align-items-center gap-2">
                    <Dropdown value={language} options={languageOptions} onChange={(e) => setLanguage(e.value)} style={{ fontSize: "13px" }} />
                    <Dropdown value={proficiency} options={proficiencyOptions} onChange={(e) => setProficiency(e.value)} style={{ fontSize: "13px" }} />
                  </div>
                </div>

                <Divider />

                {/* Job Nature */}
                <div className="mb-4">
                  <label className="block mb-1 font-semibold" style={{ fontSize: "14px" }}>
                    Job Nature
                  </label>
                  <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Only include resumes interested in the selected job natures:</p>
                  <div className="flex flex-column gap-2">
                    {[
                      { key: "fullTime", label: "Full Time" },
                      { key: "partTime", label: "Part Time" },
                      { key: "perDiem", label: "Per Diem" },
                    ].map((item) => (
                      <div key={item.key} className="flex align-items-center gap-2">
                        <Checkbox inputId={`jn_${item.key}`} checked={jobNature[item.key]} onChange={(e) => setJobNature((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                        <label htmlFor={`jn_${item.key}`} style={{ fontSize: "13px" }}>
                          {item.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <Divider />

                {/* Job Type */}
                <div className="mb-4">
                  <label className="block mb-1 font-semibold" style={{ fontSize: "14px" }}>
                    Job Type
                  </label>
                  <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Only include resumes interested in the selected job types:</p>
                  <div className="flex flex-column gap-2">
                    {[
                      { key: "employee", label: "Employee" },
                      { key: "contractor", label: "Contractor" },
                      { key: "tempAgency", label: "Temporary/Contract/Project" },
                      { key: "seasonal", label: "Seasonal" },
                    ].map((item) => (
                      <div key={item.key} className="flex align-items-center gap-2">
                        <Checkbox inputId={`jt_${item.key}`} checked={jobType[item.key]} onChange={(e) => setJobType((prev) => ({ ...prev, [item.key]: !!e.checked }))} />
                        <label htmlFor={`jt_${item.key}`} style={{ fontSize: "13px" }}>
                          {item.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <Divider />

                {/* Company Inventory */}
                <div className="mb-2">
                  <label className="block mb-1 font-semibold" style={{ fontSize: "14px" }}>
                    Company Inventory
                  </label>
                  <p style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>Only include resumes interested in the selected companies:</p>
                  <Dropdown value={company} options={companyOptions} onChange={(e) => setCompany(e.value)} placeholder="Select Company" className="w-full" style={{ fontSize: "13px" }} />
                </div>
              </div>
            )}

            {/* Search Button */}
            <div className="flex justify-content-start mt-4">
              <Button label="Search" icon="pi pi-search" onClick={handleSearch} style={{ backgroundColor: "#28a745", border: "none", fontSize: "14px", padding: "10px 28px", fontWeight: 600 }} />
            </div>
          </div>

          {/* ── Right: History Panel ── */}
          <div className="p-4" style={{ flex: 1, backgroundColor: "#fafbfc", overflowY: "auto" }}>
            <div className="mb-3 flex gap-4 border-bottom-1 border-200">
              {["RECENT HISTORY", "SAVED HISTORY"].map((label, idx) => (
                <Button
                  key={label}
                  onClick={() => setHistoryTab(idx)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "8px 0",
                    fontSize: "13px",
                    fontWeight: historyTab === idx ? 700 : 400,
                    color: historyTab === idx ? "#007bff" : "#666",
                    borderBottom: historyTab === idx ? "2px solid #007bff" : "2px solid transparent",
                    cursor: "pointer",
                    letterSpacing: "0.5px",
                  }}
                >
                  {label}
                </Button>
              ))}
            </div>

            <div className="flex flex-column gap-1">
              {(historyTab === 0 ? recentHistory : savedHistory).map((item) => (
                <div key={item.id} className="p-2" style={{ borderBottom: "1px solid #eee" }}>
                  <Button onClick={() => handleHistoryClick(item.query)} className="p-link" style={{ fontSize: "13px", textAlign: "left", display: "block", marginBottom: "4px", color: "#333" }}>
                    {item.query}
                  </Button>
                  <div className="flex align-items-center gap-1" style={{ color: "#999", fontSize: "12px" }}>
                    <i className="pi pi-clock" style={{ fontSize: "11px" }}></i>
                    <span>{item.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Toast ref={toast} />
    </>
  );
};

export default Monster;
